import { AnimatePresence, motion } from 'framer-motion';
import { RefreshCwIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { useVersionCheck } from '@/hooks/use-version-check';

const handleReload = () => {
  window.location.reload();
};

/**
 * Persistent, non-blocking banner shown when a newer frontend version has been
 * deployed. Sits top-center, below transient toasts (z-50 vs toast z-60) so
 * notifications always render on top. The user controls the reload moment;
 * we never auto-reload (workflow editor and chat both have unsaved local state
 * that would be lost).
 */
const NewVersionBanner = () => {
  const { isOutdated } = useVersionCheck();

  return (
    <AnimatePresence>
      {isOutdated && (
        <motion.div
          role='status'
          aria-live='polite'
          initial={{ y: -40, opacity: 0 }}
          animate={{ y: 0, opacity: 1, transition: { duration: 0.25 } }}
          exit={{ y: -40, opacity: 0, transition: { duration: 0.2 } }}
          className='fixed top-6 left-1/2 -translate-x-1/2 z-50 flex items-center gap-3 rounded-md border bg-background py-2.5 pl-4 pr-2.5 text-foreground shadow-lg'
        >
          <RefreshCwIcon
            className='size-4 shrink-0 text-indigo-400'
            aria-hidden
          />
          <span className='text-sm'>A new version is available</span>
          <Button size='sm' onClick={handleReload}>
            Update
          </Button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export { NewVersionBanner };
